import React from 'react';

import { Divider } from 'src/app/components/lib/divider';

import {
  WizardCardContainer,
  WizardCardDescription,
  WizardCardInfo,
  WizardCardChildrenWrapper,
  WizardCardTitle,
} from './styled';

export * from './styled';

type WizardCardProps = {
  addChildrenDivider?: boolean;
  children?: React.ReactNode;
  childrenBelowHeader?: boolean;
  className?: string;
  description?: React.ReactNode;
  descriptionSize?: number;
  infoGap?: string;
  infoWidth?: string;
  padding?: number;
  title: string;
  titleSize?: number;
};

export function WizardCard({
  addChildrenDivider,
  children,
  childrenBelowHeader,
  className,
  description,
  descriptionSize,
  infoGap,
  infoWidth,
  padding,
  title,
  titleSize,
}: WizardCardProps) {
  return (
    <WizardCardContainer
      $addChildrenDivider={addChildrenDivider}
      $childrenBelowHeader={childrenBelowHeader}
      $padding={padding}
      className={className}
    >
      <WizardCardInfo $addChildrenDivider={addChildrenDivider} $infoGap={infoGap} $infoWidth={infoWidth}>
        <WizardCardTitle $titleSize={titleSize}>{title}</WizardCardTitle>
        {description && <WizardCardDescription $descriptionSize={descriptionSize}>{description}</WizardCardDescription>}
      </WizardCardInfo>
      {addChildrenDivider && <Divider variant='compact' />}
      {children && <WizardCardChildrenWrapper>{children}</WizardCardChildrenWrapper>}
    </WizardCardContainer>
  );
}
